import React from "react";
import BooksNavbar from "../components/BooksNavbar";

const Sleep = () => {
  return (
    <div>
      <section
        className="relative min-h-screen bg-cover bg-center overflow-hidden"
        style={{ backgroundImage: "url('/water-colour-clouds.png')" }}
      >
        <BooksNavbar textColor="black" />

        <div className="relative z-10 min-h-screen pt-28 pb-16">
          {/* Page Title */}
          <div className="max-w-4xl mx-auto px-6 md:px-12 text-center mb-16">
            <h2
              className="text-lg md:text-xl text-[#5f6f4f] mb-4"
              style={{ fontFamily: "Playfair Display, serif" }}
            >
              LEARN ABOUT THE SCIENCE
            </h2>

            <div className="flex items-center w-full max-w-sm mb-6 mx-auto">
              <div className="flex-1 h-[1px] bg-[#8c8b5f]"></div>
              <span className="px-4 text-[#8c8b5f] text-lg">❖</span>
              <div className="flex-1 h-[1px] bg-[#8c8b5f]"></div>
            </div>

            <h1
              className="text-4xl md:text-6xl text-black leading-tight mb-4"
              style={{ fontFamily: "Playfair Display, serif" }}
            >
              Sleep
            </h1>

            <p
              className="text-xl md:text-2xl italic text-[#5f6f4f] leading-snug mb-6"
              style={{ fontFamily: "Playfair Display, serif" }}
            >
              The Most Powerful Brain Enhancer You're Ignoring
            </p>

            <div className="flex items-center w-full max-w-sm mx-auto">
              <div className="flex-1 h-[1px] bg-[#8c8b5f]"></div>
              <span className="px-4 text-[#8c8b5f]">❖</span>
              <div className="flex-1 h-[1px] bg-[#8c8b5f]"></div>
            </div>
          </div>

          {/* Content */}
          <div className="max-w-7xl mx-auto px-6 md:px-12">
            <div className="grid lg:grid-cols-2 gap-12 items-start">
              {/* Left Column */}
              <div className="max-w-2xl">
                <p
                  className="text-base text-black leading-relaxed mb-6"
                  style={{ fontFamily: "Playfair Display, serif" }}
                >
                  We've all done it. You stay up a little too late. One more
                  episode. One more chapter. One more email. After all, what's
                  the worst that can happen? The next morning, you feel a bit
                  tired. Perhaps you need an extra coffee. Or so you think.
                </p>

                <p
                  className="text-base text-black leading-relaxed mb-6"
                  style={{ fontFamily: "Playfair Display, serif" }}
                >
                  What if I told you that after just one poor night's sleep,
                  your brain becomes measurably worse at holding information in
                  mind, staying focused, making decisions, and regulating
                  emotions? In other words, the very mental skills that help you
                  navigate daily life — your executive functions — begin to
                  unravel.
                </p>

                <p
                  className="text-base text-black leading-relaxed mb-6"
                  style={{ fontFamily: "Playfair Display, serif" }}
                >
                  A minor inconvenience suddenly feels like a crisis.
                  Concentrating on a simple task becomes exhausting. You reread
                  the same paragraph over and over again. Someone's neutral
                  expression looks hostile. A harmless comment feels like a
                  personal attack.
                </p>

                <p
                  className="hidden xl:block text-base text-black leading-relaxed mb-6"
                  style={{ fontFamily: "Playfair Display, serif" }}
                >
                  A few years ago, my team partnered with the BBC to investigate
                  exactly what happens when sleep is restricted. After just four
                  hours of sleep, BBC Medical Editor Fergus Walsh showed obvious
                  declines in several aspects of executive function. But what
                  struck us most wasn't his test performance; it was his mood.
                </p>

                {/* <p
                  className="text-base text-black leading-relaxed mb-6"
                  style={{ fontFamily: "Playfair Display, serif" }}
                >
                  A few years ago, my team partnered with the BBC to investigate
                  exactly what happens when sleep is restricted. After just four
                  hours of sleep, BBC Medical Editor Fergus Walsh showed obvious
                  declines in several aspects of executive function. But what
                  struck us most wasn't his test performance; it was his mood.
                </p> */}
              </div>

              {/* Right Image */}
              <div className="flex justify-center lg:justify-end">
                <img
                  src="/sleep.png"
                  alt="Sleep"
                  className="w-full max-w-[700px]"
                />
              </div>
            </div>

            {/* Full Width Text */}
            <div className="mt-2">
              <p
                className="xl:hidden text-base text-black leading-relaxed mb-6"
                style={{ fontFamily: "Playfair Display, serif" }}
              >
                A few years ago, my team partnered with the BBC to investigate
                exactly what happens when sleep is restricted. After just four
                hours of sleep, BBC Medical Editor Fergus Walsh showed obvious
                declines in several aspects of executive function. But what
                struck us most wasn't his test performance; it was his mood.
              </p>

              <p
                className="text-base text-black leading-relaxed mb-6"
                style={{ fontFamily: "Playfair Display, serif" }}
              >
                The cheerful, energetic volunteer we'd tested the previous
                evening had become irritable, withdrawn, and noticeably less
                able to regulate his emotions. Brain scans revealed that key
                regions of the frontal lobes were simply not working as
                effectively as they had the night before.
              </p>

              <p
                className="text-base text-black leading-relaxed mb-6"
                style={{ fontFamily: "Playfair Display, serif" }}
              >
                Which raises a rather unsettling possibility. How many of the
                bad decisions we make, arguments we start, opportunities we
                miss, and mistakes we regret are really the result of a tired
                brain?
              </p>

              <p
                className="text-base text-black leading-relaxed mb-6"
                style={{ fontFamily: "Playfair Display, serif" }}
              >
                In <em>Think Before You Think</em>, you'll discover why sleep
                may be the single most underrated tool for improving executive
                function, what happens inside your brain when you don't get
                enough of it, and why the difference between feeling sharp and
                feeling foggy may have less to do with intelligence than with
                what happened the night before.
              </p>

              <p
                className="text-base text-black leading-relaxed"
                style={{ fontFamily: "Playfair Display, serif" }}
              >
                Because sometimes the smartest thing you can do is go to bed.
              </p>

              {/* Creyos Test Button */}
                <div className="mt-12 text-center">
                  <a
                    href="https://habstudy.com"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="bg-[#D4AF37] text-black px-4 py-2 font-semibold"
                  >
                    IF YOU'D LIKE TO TRY SOME OF THE TESTS BEHIND THE SCIENCE,
                    CLICK HERE
                  </a>
                </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Sleep;
